/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { WorkspaceDatabaseKeys } from './workspace-database-keys';
import { AppVariables } from '@shared';

// todo: check which are nullable and set them nullable in rxdb
export const columnSchema: RxJsonSchema<any> = {
	version: 1,
	primaryKey: {
		key: WorkspaceDatabaseKeys.columns.primaryKeyComposed,
		fields: [WorkspaceDatabaseKeys.columns.columnName, WorkspaceDatabaseKeys.columns.tableName],
		separator: WorkspaceDatabaseKeys.columns.separator
	},
	properties: {
		[WorkspaceDatabaseKeys.columns.primaryKeyComposed]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[WorkspaceDatabaseKeys.columns.columnName]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.tableName]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.tableId]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.columnLabel]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.dataType]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.width]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.decimalPlaces]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.displayOrder]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.editStyle]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.defaultValue]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.calculationFormula]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.isColumnNullable]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.inheritValues]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.tableModule]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.displayColumn]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.isEditable]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.columnStyle]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.codeTableName]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.codeDisplayColumnName]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.codeDataColumnName]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.inheritValuesColumn]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.columns.minimumValue]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.columns.maximumValue]: {
			type: 'number'
		}
	},
	type: 'object',
	description: ''
};
